<div class="page-content page-fill">
    <div class="grid-fill">
        <dx-data-grid #accountsGrid [dataSource]="visits" keyExpr="id" (onToolbarPreparing)="onToolbarPreparing($event)">
            <dxi-column dataField="person.displayName" caption="Person" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="type.name" caption="Type"></dxi-column>
            <dxi-column dataField="date" [width]="120" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="visitedBy.displayName" caption="Visited By"></dxi-column>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <a [routerLink]="['/people/visits/' + cell.data.id]">{{ cell.text || '(blank)' }}</a>
            </div>

            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <div *dxTemplate="let data of 'toolbarButtons'" class="d-flex">
                <dx-button text="Add" type="default" (onClick)="open()"></dx-button>
                <dx-button text="Open" type="primary" (onClick)="open(accountsGrid.focusedRowKey)"></dx-button>
                <label class="d-inline-block ms-3 me-2 pt-2">Month</label>
                <dx-date-box
                    [(value)]="selectedMonth"
                    (valueChange)="monthChanged()"
                    [displayFormat]="'monthAndYear'"
                    [calendarOptions]="{ maxZoomLevel: 'year', minZoomLevel: 'decade' }"
                ></dx-date-box>
            </div>
        </dx-data-grid>
    </div>
</div>
